import { api } from "api/common";
import {
  ABOUT_ME_URL,   // currently not used
  DEACTIVATE_SELF,
  RESET_PASSWORD,
  UPDATE_ME_URL,
  UPDATE_ROLE,
} from "api/constants";
import { setToastMessage } from "components/app/actions";
import { setAuthState } from "components/Auth/actions";
import { push } from "connected-react-router";
import { createActionsHook } from "react-redux-actions-hook";
import { AppRouteURI } from "router/RoleBasedAccess";
import { SettingsActionType } from "./constants";

// currently not used
export const aboutMe = () => {
  return (dispatch) => {
    api(ABOUT_ME_URL, {}, dispatch)
      .then((res) => {
        dispatch(setProfileData(res.data));
      })
      .catch((error) => {
        //Handle Error
      });
  };
};

const dummy = () => {
  //do nothing
};

export const updateMe = (data, callback = dummy) => {
  return (dispatch, stateFn) => {
    const userdata = stateFn().settings.profile.user;
    api(
      `${UPDATE_ME_URL}`,
      { method: "PUT", body: JSON.stringify(userdata) },
      dispatch
    )
      .then((resp) => {
        dispatch(aboutMe());   // currently not used
        dispatch(
          setToastMessage({
            message: resp.message || "Profile details updated",
            type: "success",
          })
        );
        callback();
      })
      .catch((error) => {
        //Handle Error
        dispatch(
          setToastMessage({
            message: error.message || "Unable to update profile",
            type: "error",
          })
        );
      });
  };
};

export const updateRole = (data) => {
  return (dispatch, stateFn) => {
    const state = stateFn().settings.profile.user;
    api(
      `${UPDATE_ROLE}/${state.role}`,
      { method: "PUT", body: JSON.stringify({}) },
      dispatch
    )
      .then((res) => {
        dispatch(
          setToastMessage({
            message: res.message || "Role change request sent successfully",
            type: "success",
          })
        );
        dispatch(aboutMe());   // currently not used
      })
      .catch((error) => {
        //Handle Error
      });
  };
};

export const deactivateSelf = (data) => {
  return (dispatch) => {
    api(`${DEACTIVATE_SELF}`, { method: "POST" }, dispatch)
      .then((res) => {
        dispatch(
          setToastMessage({
            message: res.message,
            type: "success",
          })
        );
        dispatch(setAuthState(false));
        dispatch(push(AppRouteURI.LOGOUT));
      })
      .catch((error) => {
        //Handle Error
      });
  };
};

export const onPasswordChange = (callback = dummy) => {
  return (dispatch, stateFn) => {
    const { oldPassword, newPassword } = stateFn().settings.pwdChangeContent;
    api(
      `${RESET_PASSWORD}`,
      {
        method: "POST",
        body: JSON.stringify({
          old_password: oldPassword,
          new_password: newPassword,
        }),
      },
      dispatch
    )
      .then((res) => {
        dispatch(
          setToastMessage({
            message: res.message,
            type: "success",
          })
        );
        dispatch(aboutMe());
        callback();
      })
      .catch((error) => {
        //Handle Error
      });
  };
};

export const setTab = (selectedTab) => {
  return { type: SettingsActionType.SET_TAB, selectedTab };
};
export const openPwdChangeDialog = (isOpen) => {
  return { type: SettingsActionType.SET_OPEN_PWD_DIALOG, isOpen };
};
export const openDeactivateConfirmationDialog = (isOpen) => {
  return { type: SettingsActionType.SET_OPEN_DEACT_DIALOG, isOpen };
};
export const setPwdDialogContent = (content) => {
  return { type: SettingsActionType.SET_PWD_DIALOG_CONTENT, content };
};

export const setProfileData = (data) => {
  for (const prop in data.user) {
    if (data.user[prop] === null) {
      data.user[prop] = "";
    }
  }
  return { type: SettingsActionType.SET_PROFILE, data };
};

export default createActionsHook({
  setTab,
  aboutMe,  // currently not used
  setProfileData,
  updateMe,
  updateRole,
  openPwdChangeDialog,
  setPwdDialogContent,
  onPasswordChange,
  deactivateSelf,
  openDeactivateConfirmationDialog,
});
